import { Coins, Users } from "lucide-react"
import { useTranslation } from "react-i18next"

import { CrewStatTile } from "@/components/creator/crew-stat-tile"
import type { CrewStats } from "@/types/crew-hub"

/**
 * OKS-474 — §18 social-proof stat row (UX Spec §2.2).
 *
 * Two equal tiles side-by-side (2-up at every breakpoint within the
 * centered content column): crew size ("N creators", `Users`) + total
 * coins given ("N coins given", `Coins`, accent). Hidden by the page in
 * the empty-crew state (PRD Q6) — this component always renders both
 * tiles when mounted.
 */
interface CrewStatRowProps {
  stats: CrewStats
}

export function CrewStatRow({ stats }: CrewStatRowProps) {
  const { t } = useTranslation()

  return (
    <div data-testid="crew-stat-row" className="flex gap-3 px-4">
      <CrewStatTile
        value={stats.crew_size}
        label={t("crew_hub.stats.creators")}
        icon={Users}
        testId="crew-stat-size"
      />
      <CrewStatTile
        value={stats.coins_given}
        label={t("crew_hub.stats.coins_given")}
        icon={Coins}
        accent
        testId="crew-stat-coins"
      />
    </div>
  )
}
